<template>
  <!-- 使用 ref 来直接操作 DOM 元素的样式 -->
  <div ref="playerContainer" class="tengxunyun" :class="{ 'tengxunyun-horizontal': screenType === 1 }">
    <video
      class="tengxunyun-video"
      :id="playerId"
      preload="auto"
      playsinline
      webkit-playsinline
      style="object-fit: cover;"
    ></video>
	
	<div class="video-cover" v-if="isShowCover && backgroundUrl">
		<div class="video-cover-box">
			<img class="video-cover-box-img" :src="backgroundUrl" alt="" />
		</div>
	</div>
	<!-- <div class="video-cover-box-play" @click="refreshPlay" v-if="isRefresh == 1">
		<img src="../../assets/image/dongtai_bofang_44@2x.png" alt="" />
	</div> -->
	<playSvga ref="svga" v-if="show_svga"/>
	
  </div>
</template>

<script>
import { getChatRoomDetails } from "@/api/zhibo";
import playSvga from "../playSvga/playSvga.vue";
export default {
  name: "tengxunyun",
  components: {
    playSvga
  },
  data() {
    return {
      data: "",
      player: null,
      licenseUrl: "https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license",
      playerId: null,
      // 区分横竖屏宽高比（0=竖屏9:16，1=横屏16:9）
      verticalAspectRatio: 9 / 16, // 竖屏
      horizontalAspectRatio: 16 / 9, // 横屏
      currentAspectRatio: 9 / 16, // 当前使用的宽高比（初始默认竖屏）
      screenType: 0, // 存储接口返回的屏幕类型（0=竖屏，1=横屏）
	  show_svga:true,
	  muted:true,
	  isShowCover:true,
	  backgroundUrl:'',
	  isRefresh: sessionStorage.getItem('isPageRefreshed')
    };
  },
  mounted() {
	this.playerId = this.generateId();
    // 1. 首次加载时计算一次尺寸
    this.calculatePlayerSize();

    // 2. 监听窗口大小变化事件，动态调整尺寸
    window.addEventListener("resize", this.calculatePlayerSize);

    // 3. 获取直播信息并初始化播放器
	
    this.getChatRoomDetails();
	
	window.addEventListener("beforeunload", this.updateRefresh)
  },
  beforeDestroy() {
    // 步骤1：移除 resize 事件监听（保留你原有的有效逻辑）
    window.removeEventListener("resize", this.calculatePlayerSize);
    console.log('刷新页面')
    // 步骤2：完整清理播放器资源（核心优化部分）
    if (this.player) {
      try {
        // 优先暂停播放，立即终止音频输出（防止声音残留）
        this.player.pause();
        // 清空播放地址，切断直播流网络连接
        this.player.src('');
        // 移除自定义绑定的 webrtcevent 事件监听器（防止内存泄漏）
        this.player.off('webrtcevent');
        // 再执行销毁方法，释放播放器内核资源
        this.player.dispose();
        console.log('播放器已完整销毁，音频和事件已清理');
      } catch (e) {
        console.warn('播放器清理过程中出现异常，忽略继续:', e);
      }
      // 步骤3：解除播放器实例引用，方便GC彻底回收
      this.player = null;
    }
  
    // 步骤4：重置其他相关状态（可选，增强组件复用安全性）
    this.playerId = null;
    this.isShowCover = true;
    this.show_svga = false;
    this.muted = true;
  },
  methods: {
	updateRefresh(){
		sessionStorage.setItem('isPageRefreshed', 1);
	},
    generateId() {
      return "player-container-" + Date.now();
    },

    calculatePlayerSize() {
      // 获取组件的根 DOM 元素
      const container = this.$refs.playerContainer;
      if (!container) return;

      // 核心修改1：获取父容器的实际宽度（而非视口宽度），避免撑大父容器
      const parentContainer = container.parentElement;
      const parentWidth = parentContainer.offsetWidth; // 父容器可用宽度
      const viewportHeight = window.innerHeight;

      // 计算视频播放器可用的最大高度 (减去固定的 126px)
      const maxAvailableHeight = viewportHeight - 126;

      // 核心修改2：根据屏幕类型确定播放器最大可用宽度
      let maxPlayerWidth;
      if (this.screenType === 1) {
        // 横屏：限制为父容器的 50%，不撑大父容器（已修改 0.6 → 0.5）
        maxPlayerWidth = parentWidth * 0.5;
      } else {
        // 竖屏：使用父容器的 100% 宽度，保持原有逻辑
        maxPlayerWidth = parentWidth;
      }

      // 使用当前动态宽高比（currentAspectRatio）计算理论宽度
      const calculatedWidth = maxAvailableHeight * this.currentAspectRatio;

      let finalWidth, finalHeight;

      // 核心修改3：判断理论宽度是否超过「播放器最大可用宽度」（横屏50%/竖屏100%父容器宽度）
      if (calculatedWidth > maxPlayerWidth) {
        // 如果超过了，以播放器最大可用宽度为最终宽度
        finalWidth = maxPlayerWidth;
        // 根据最终宽度反算出最终高度
        finalHeight = finalWidth / this.currentAspectRatio;
      } else {
        // 如果没超过，以最大可用高度为最终高度
        finalHeight = maxAvailableHeight;
        // 最终宽度为计算出的宽度
        finalWidth = calculatedWidth;
      }

      // 额外防护：确保最终高度不超过最大可用高度，防止溢出
      if (finalHeight > maxAvailableHeight) {
        finalHeight = maxAvailableHeight;
        finalWidth = finalHeight * this.currentAspectRatio;
      }

      // 将计算出的最终尺寸应用到 DOM 元素上
      container.style.width = `${finalWidth}px`;
      container.style.height = `${finalHeight}px`;
    },

    async getChatRoomDetails() {
      try {
        const res = await getChatRoomDetails({ liveId: this.$route.query.liveId });
        this.data = res.data;
        this.backgroundUrl = res.data.chatRoomDetails.bgUrl;
        // 获取接口返回的 screenType，默认值为 0（竖屏）防止字段不存在
        this.screenType = res.data.chatRoomDetails.screenType || 0;
        
        // 根据 screenType 切换当前宽高比
        this.currentAspectRatio = this.screenType === 1 
          ? this.horizontalAspectRatio // 1=横屏，使用16:9
          : this.verticalAspectRatio;  // 0=竖屏，使用9:16
        
        // 切换宽高比后，重新计算播放器尺寸（让变更立即生效）
        this.calculatePlayerSize();

        if (!this.player) {
          // 确保在计算完尺寸后再初始化播放器，这样播放器能获得正确的容器大小
          this.player = TCPlayer(this.playerId, {
            sources: [
              {
                src: res.data.chatRoomDetails.pullUrl, // 播放地址
              },
            ],
            licenseUrl: this.licenseUrl, // license 地址
            autoplay: true,
            controls: false,
            webrtcConfig: {
              connectRetryCount: 999999,
            },
			errorDisplay: false,
          });
		  this.player.on('webrtcevent', (event) => {
		    console.log(event.data.code)
		    if(event.data.code == 1005 || event.data.code == 1009){
		      this.isShowCover = true
		    }
		    if(event.data.code == 1003){
		      this.isShowCover = false
		      console.log(this.isShowCover,'我隐藏了封面')
		    }
		  });
		  this.player.on('error', (event) => {
		    console.log(event,'视频播放出现错误时触发。')
		  });
        } else {
          // 如果 player 已存在（例如，路由参数变化但组件复用），更新播放地址
          this.player.src(res.data.chatRoomDetails.pullUrl);
          this.player.play();
          // 组件复用时，补充尺寸计算，确保播放器适配新尺寸
          this.calculatePlayerSize();
        }
      } catch (error) {
        console.error("获取直播信息失败:", error);
      }
    },
	//播放礼物
	addGiftToQueue(data){
		this.$refs.svga.addGiftToQueue(data)
	},
	//关闭开启声音
	updateMuted(data){
		console.log(data)
		this.player.muted(data?false:true);
	},
	//关闭开启特性
	updateSvga(data){
		console.log(data)
		this.show_svga = data
	},
	//刷新浏览器播放视频
	refreshPlay(){
		this.isRefresh = 0
		sessionStorage.setItem('isPageRefreshed', 1);
		this.player.src(this.data.chatRoomDetails.pullUrl);
		this.player.play();
	}
  },
};
</script>

<style scoped lang="scss">
	.tengxunyun {
	  /* 移除固定的 height，由 JS 动态设置 */
	  width: 100%;
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  /* 使用 margin 来将容器垂直居中 */
	  margin: 0 auto;
	  position: relative;
	  /* 尺寸过渡效果，横竖屏切换更顺滑 */
	  transition: width 0.3s ease, height 0.3s ease;
	  /* 核心补充：防止播放器自身撑大父容器 */
	  box-sizing: border-box;
	  max-width: 100%;
	  max-height: 100%;
	  
	}

	// 横屏专属样式：实现上下左右居中
	.tengxunyun-horizontal {
	  // 让播放器在父容器中水平居中（margin: 0 auto 已保留，增强保障）
	  margin: auto;
	  // 同时确保父容器的布局支持垂直居中（自身作为弹性项，依赖父容器为 flex）
	  position: relative;
	  // 额外补充：防止居中后溢出
	  box-sizing: border-box;
	}

	// 关键补充：给播放器的直接父容器添加弹性布局，支持垂直居中
	:deep(.tengxunyun-parent) {
	  display: flex;
	  flex-direction: column;
	  justify-content: center;
	  align-items: center;
	  height: 100%; // 父容器需设置高度，否则垂直居中无效
	}

	.tengxunyun-video {
	  /* 让视频填满父容器 */
	  width: 100%;
	  height: 100%;
	  position: relative;
	  z-index: 2;
	}
	.video-cover{
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 1;
	}
	.video-cover-box{
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.video-cover-box-img{
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.video-cover-box span{
		font-family: MiSans, MiSans;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
		line-height: 19px;
		z-index: 1;
	}
	.video-cover-box-play{
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		z-index: 1000;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.video-cover-box-play img{
		width: 56px;
		height: 56px;
	}
</style>
<style>
	.video-js{
		background: transparent ;
	}
	.tcp-skin.vjs-seeking .tcp-loading-spinner, .tcp-skin.vjs-waiting .tcp-loading-spinner {
		display: none;
	}
	.tcp-skin .tcp-loading-spinner {
		display: none !important;
	}
</style>


// WEBPACK FOOTER //
// tengxunyun.vue?0f5a9c9b